/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/components/callback/callback.component';
import * as i2 from '../../../../app/shared/auth.service';
const styles_CallbackComponent:any[] = ([] as any[]);
export const RenderType_CallbackComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CallbackComponent,data:{}});
export function View_CallbackComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_CallbackComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_CallbackComponent_0,
      RenderType_CallbackComponent)),i0.ɵdid(49152,(null as any),0,i1.CallbackComponent,
      [i2.AuthService],(null as any),(null as any))],(null as any),(null as any));
}
export const CallbackComponentNgFactory:i0.ComponentFactory<i1.CallbackComponent> = i0.ɵccf('ng-component',
    i1.CallbackComponent,View_CallbackComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29tcG9uZW50cy9jYWxsYmFjay9jYWxsYmFjay5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29tcG9uZW50cy9jYWxsYmFjay9jYWxsYmFjay5jb21wb25lbnQudHMiLCJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvQ2xpZW50L2FwcC9jb21wb25lbnRzL2NhbGxiYWNrL2NhbGxiYWNrLmNvbXBvbmVudC50cy5DYWxsYmFja0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy1jb21wb25lbnQ+PC9uZy1jb21wb25lbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7a0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./Client/$$_gendir/app/components/callback/callback.component.ngfactory.ts